import {
  map,
  mergeMap,
  exhaustMap,
  catchError,
  concatMap,
  switchMap,
} from 'rxjs/operators';
import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as allActions from './stock-correction.actions';
import { StockroomService } from '@core/services/stockroom/stockroom-api';
import { AppService } from '@core/services/app/app-api';
import { Store } from '@ngrx/store';
import { StockCorrectionState } from './stock-correction.reducer';
import { ToastService } from '@core/services/toast-api';
import { NotificationsService } from '@core/services/notifications/notifications-api';
import { saveAs } from 'file-saver';
import { LocationService } from '@core/services/location/location-api';
declare var moment: any;

@Injectable()
export class StockCorrectionEffects {
  currentUser: any = this.appService.getUserData();
  constructor(
    private actions$: Actions,
    private stockroomService: StockroomService,
    private appService: AppService,
    private store: Store<StockCorrectionState>,
    private toastService: ToastService,
    private notificationsService: NotificationsService,
    private locationService: LocationService
  ) { }

  loadReasonCodes$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(allActions.loadReasonCodes),
      mergeMap(action => {
        return this.stockroomService.getReasonCodesAsObservable().pipe(
          map((res: any) => {
            let defaultStockroom = JSON.parse(
              sessionStorage.getItem('cStockroomAndOrg')!
            ).stockroom;
            let type = defaultStockroom.stockroomType;
            let reasonCodeFilter: Array<any> = [];
            let reasonCodes: Array<any> = [];
            res.forEach((element: any) => {
              reasonCodeFilter.push({
                value: element.id,
                description: element.reasonCode,
              });
              if (type == 'Regular' && element.isOverwrite != 'Y') {
                reasonCodes.push(element);
              } else if (
                type != 'Regular' &&
                (element.isOverwrite == 'Y' || element.isOverwrite == 'N')
              ) {
                reasonCodes.push(element);
              }
            });
            return allActions.loadReasonCodesSuccess({
              reasonCodes: reasonCodes,
              reasonCodeFilter: reasonCodeFilter,
            });
          }),
          catchError(error =>
            of(
              allActions.loadReasonCodesSuccess({
                reasonCodes: [],
                reasonCodeFilter: [],
              })
            )
          )
        );
      })
    );
  });

  loadProducts$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(allActions.loadProducts),
      concatMap(action => {
        return this.stockroomService
          .getProductsAsObserveble(
            action.offset,
            action.limit,
            action.description,
            action.sortBy,
            action.filterOpts
          )
          .pipe(
            mergeMap((resp: any, index: number) => {

              this.store.dispatch(
                allActions.loadProductTotalCount({
                  totalCount: resp.totalCount,
                })
              );

              if (resp.data.length == 0) this.store.dispatch(
                allActions.loadProductSuccess({ products: [] })
              );
              const productIds = resp.data.map((item: any) => {
                if (item.batchManagementEnabled == 1 || item.expiryDateManagementenabled == 1) {
                  return parseInt(item.id);
                }
                return null;
              }).filter((item: any) => item);

              return this.stockroomService.getProductsBatches(productIds)
                .pipe(
                  map((batchesResp: any) => {
                    if (!batchesResp || !Object.keys(batchesResp).length) return resp.data;
                    resp.data = resp.data.map((item: any) => {
                      if (item.batchManagementEnabled == 1 || item.expiryDateManagementenabled == 1) {
                        item.batches = batchesResp[item.id]?.data || [];
                        item.batches.forEach((batch: any) => {
                          batch.expiryDate = new Date(
                            moment(batch.expiryDate).format('llll')
                          );
                          batch.expiryDateNew = new Date(
                            moment(batch.expiryDate).format('llll')
                          );
                          batch['dynamicExpiryDate'] = batch.dynamicExpirydate ? new Date(
                            moment(batch.dynamicExpirydate).format('llll')
                          ) : null;
                          batch['dynamicExpiryDateNew'] = batch.dynamicExpirydate ? new Date(
                            moment(batch.dynamicExpirydate).format('llll')
                          ) : null;
                        });
                        item.batchControlled = true;
                      } else {
                        item.batches = [];
                        item.batchControlled = false;
                      }
                      if (item.status == 'offline' || item.freeze) {
                        item._isCheckboxDisabled = true;
                      } else {
                        item._isCheckboxDisabled = false;
                      }
                      item._selected = false;
                      return item;
                    });
                    return resp.data;
                  }));


            }),
            concatMap((mergedResponse: any) => {
              return of(
                allActions.loadProductSuccess({ products: mergedResponse })
              );
            }),
            catchError(error =>
              of(allActions.loadProductSuccess({ products: [] }))
            )
          );
      })
    );
  });

  validateStockCorrection$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(allActions.validateStockCorrection),
      concatMap((action: any) => {
        return this.stockroomService
          .validateStockCorrectionAsObservable(action.dataSend)
          .pipe(
            map((res: any) => {
              this.store.dispatch(
                allActions.correctStockCorrection(action.dataSend)
              );
              return allActions.validateStockCorrectionSuccess({
                status: true,
                message: null,
              });
            }),
            catchError(err => {
              console.log("err", err);
              let message = err?.error.label ?? err?.error.errorMessage ?? '';
              this.toastService.show('error', message, undefined, true, 3000);
              return of(
                allActions.validateStockCorrectionSuccess({
                  status: false,
                  message: message,
                })
              );
            })
          );
      })
    );
  });

  correctStockCorrection$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(allActions.correctStockCorrection),
      concatMap((action: any) => {
        return this.stockroomService
          .correctStockCorrectionAsObservable(action)
          .pipe(
            map((result: any) => {
              this.toastService.show(
                'success',
                result.status,
                undefined,
                true,
                2000
              );
              this.notificationsService.getNotificationsCount();
              return allActions.correctStockCorrectionSuccess({
                status: true,
                message: null,
              });
            }),
            catchError(err => {
              return of(
                allActions.correctStockCorrectionSuccess({
                  status: false,
                  message: null,
                })
              );
            })
          );
      })
    );
  });

  importStockCorrection$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(allActions.importStockCorrection),
      concatMap((action: any) => {
        let formData = new FormData();
        formData.append('file', action.file);
        return this.stockroomService
          .importStockCorrectionAsObservable(formData)
          .pipe(
            map((res: any) => {
              if (Object.keys(res.data).length == 0) {
                this.toastService.show(
                  'error',
                  res.status,
                  undefined,
                  false,
                  5000
                );
              } else {
                this.toastService.show(
                  'success',
                  res.status,
                  undefined,
                  true,
                  5000
                );
              }
              return allActions.importStockCorrectionSuccess({
                status: true,
                products: res.data,
              });
            }),
            catchError(err => {
              const message = (err.error && err.error.errorMessage) ? err.error.errorMessage.replace('400 :', '') : err.message;
              this.toastService.show(
                'error',
                message,
                undefined,
                true,
                10000
              );
              return of(
                allActions.importStockCorrectionSuccess({
                  status: false,
                  products: [],
                })
              );
            })
          );
      })
    );
  });
  loadProductsForExport$ = createEffect((): any => {
    return this.actions$.pipe(
      ofType(allActions.loadProductsForExport),
      concatMap((action: any) => {
        return this.stockroomService
          .getProductsAsObserveble(0, 0, undefined, undefined, { 'status': 'online' })
          .pipe(
            mergeMap((resp: any, index: number) => {
              if (resp.data.length === 0) {
                this.store.dispatch(allActions.loadProductSuccess({ products: [] }));
                return of([]);
              }

              const productIds = resp.data
                .map((item: any) => (item.batchManagementEnabled === 1 || item.expiryDateManagementenabled === 1 ? parseInt(item.id) : null))
                .filter((item: any) => item !== null);

              return this.stockroomService.getProductsBatches(productIds).pipe(
                map((batchesResp: any) => {
                  if (!batchesResp || Object.keys(batchesResp).length === 0) {
                    return resp.data;
                  }
                  resp.data = resp.data.map((item: any) => {
                    if (item.batchManagementEnabled === 1 || item.expiryDateManagementenabled === 1) {
                      item.batches = batchesResp[item.id]?.data || [];
                    }
                    return item;
                  });
                  return resp.data;
                }),
                catchError(() => of(resp.data)) // Ensures continuation if getProductsBatches fails
              );
            }),
            concatMap((mergedResponse: any) => {
              return of(
                allActions.exportStockCorrection({
                  products: mergedResponse,
                  userSelection: action.userSelection,
                  reasonCodeSelection: action.reasonCodeSelection,
                })
              );
            })
          );
      })
    );
  });
  exportStockCorrection$ = createEffect((): any => {
    return this.actions$.pipe(
      ofType(allActions.exportStockCorrection),
      concatMap((action: any) => {
        let dataSend = {
          reasonCode: action.reasonCodeSelection,
          user: action.userSelection,
          products: action.products.filter((el: any) => !el.freeze),
        };
        return this.stockroomService.exportStockCorrection(dataSend).pipe(
          map((res: any) => {
            let blob: any = new Blob([res.body], {
              type: 'application/vnd.ms-excel;charset=UTF-8',
            });
            const url = window.URL.createObjectURL(blob);
            const file = new File([blob], 'exportToExcel.xls', {
              type: 'application/vnd.ms-excel;charset=UTF-8',
            });
            saveAs(file);
            return allActions.exportStockCorrectionSuccess();
          }),
          catchError(error => {
            this.toastService.show(
              'error',
              'Error',
              error.message?.replace('401 OK', ''),
              true,
              3000
            );
            return of(allActions.exportStockCorrectionSuccess());
          })
        );
      })
    );
  });

  loadPiLocations$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(allActions.loadPiLocations),
      mergeMap(action => {
        return this.stockroomService
          .getPhysicalInventoryCountLocationsAsObservable()
          .pipe(
            map((res: any) => {
              return allActions.loadPiLocationsSuccess({ piLocations: res });
            }),
            catchError(error =>
              of(allActions.loadPiLocationsSuccess({ piLocations: [] }))
            )
          );
      })
    );
  });

  loadPiProducts$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(allActions.loadPiProducts),
      mergeMap((action: any) => {

        return this.stockroomService
          .getPICountProductsAsObservable(
            action.piCountId,
            action.offset,
            action.limit,
            action.sortBy,
            action.filterOpts
          )
          .pipe(
            map((res: any) => {
              let products = res.data.map((item: any) => {
                let _data = {
                  ...item,
                  catalogNo: item.product.catalogNo,
                  custCatalogNo: item.product.custCatalogNo,
                  description: item.product.description,
                  vendorName: item.product.vendorName,
                  locationName: item.product.locationName,
                  stockroomUnitQty: item.product.stockroomUnitQty,
                  reasonCode: item.reasonCode ? item.reasonCode.id : null,
                  reasonCodeName: item.reasonCode
                    ? item.reasonCode.reasonCode
                    : null,
                };

                return _data;
              });
              return allActions.loadPiProductsSuccess({
                piProducts: products,
                totalCount: res.totalCount
              });
            }),
            catchError(error =>
              of(
                allActions.loadPiProductsSuccess({
                  piProducts: [],
                  totalCount: 0,
                })
              )
            )
          );
      })
    );
  });

  exportPiCount$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(allActions.exportPiCount),
      mergeMap(action => {
        return this.stockroomService.exportPICount(action.piCountId).pipe(
          map((res: any) => {
            let blob: any = new Blob([res.body], {
              type: 'application/vnd.ms-excel;charset=UTF-8',
            });
            const url = window.URL.createObjectURL(blob);
            const file = new File([blob], 'exportToExcel.xls', {
              type: 'application/vnd.ms-excel;charset=UTF-8',
            });
            saveAs(file);
            return allActions.exportPiCountSuccess();
          }),
          catchError(error => {
            this.toastService.show(
              'error',
              'Error',
              error.message?.replace('401 OK', ''),
              true,
              3000
            );
            return of(allActions.exportPiCountSuccess());
          })
        );
      })
    );
  });

  importPiCount$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(allActions.importPiCount),
      mergeMap(action => {
        let formData = new FormData();
        formData.append('file', action.file);
        return this.stockroomService
          .importPICountAsObservable(action.piCountId, formData)
          .pipe(
            map((res: any) => {
              if (Object.keys(res.data).length == 0) {
                this.toastService.show(
                  'error',
                  res.status,
                  undefined,
                  true,
                  5000
                );
              } else {
                this.toastService.show(
                  'success',
                  res.status,
                  undefined,
                  true,
                  5000
                );
              }
              return allActions.importPiCountSuccess({ products: res.data });
            }),
            catchError(error => {
              if (error.error && error.error.errorMessage)
                this.toastService.show(
                  'error',
                  'Error',
                  error.error.errorMessage.replace('400 :', ''),
                  true,
                  5000
                );
              else
                this.toastService.show(
                  'success',
                  error.status,
                  undefined,
                  true,
                  5000
                );
              return of(allActions.importPiCountSuccess({ products: [] }));
            })
          );
      })
    );
  });

  cancelPiCount$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(allActions.cancelPiCount),
      mergeMap(action => {
        return this.stockroomService
          .cancelPICountAsObservable(action.piCountId)
          .pipe(
            map((res: any) => {
              this.store.dispatch(allActions.loadPiLocations());
              return allActions.cancelPiCountSuccess({
                status: true,
                message: res.status,
              });
            }),
            catchError(error => {
              this.toastService.show('error', '', undefined, true, 2000);
              return of(
                allActions.cancelPiCountSuccess({
                  status: false,
                  message: null,
                })
              );
            })
          );
      })
    );
  });

  startPiCount$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(allActions.startPiCount),
      mergeMap(action => {
        return this.stockroomService
          .startPICountAsObservable(action.piCountId)
          .pipe(
            map((res: any) => {
              this.store.dispatch(allActions.loadPiLocations());
              return allActions.startPiCountSuccess({
                status: true,
                message: res.status,
              });
            }),
            catchError(error => {
              this.toastService.show(
                'error',
                '404 : Freez or Offline mode is Empty on selected Products',
                undefined,
                true,
                2000
              );
              return of(
                allActions.startPiCountSuccess({ status: false, message: null })
              );
            })
          );
      })
    );
  });

  savePiCount$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(allActions.savePiCount),
      mergeMap((action: any) => {
        return this.stockroomService
          .savePICountAsObservable(action.piCountId, action.saveData)
          .pipe(
            map((res: any) => {
              this.store.dispatch(allActions.loadPiLocations());
              return allActions.savePiCountSuccess({
                status: true,
                message: res.status,
              });
            }),
            catchError(error => {
              let message =
                error?.erroror.label ?? error?.error.errorMessage ?? '';
              this.toastService.show('error', message, undefined, true, 2000);
              return of(
                allActions.savePiCountSuccess({ status: false, message: null })
              );
            })
          );
      })
    );
  });

  completePiCount$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(allActions.completePiCount),
      mergeMap((action: any) => {
        return this.stockroomService
          .completePICountAsObservable(action.piCountId, action.completeData)
          .pipe(
            map((res: any) => {
              this.store.dispatch(allActions.loadPiLocations());
              return allActions.completePiCountSuccess({
                status: true,
                message: res.status,
              });
            }),
            catchError(error => {
              console.log('error', error);
              this.toastService.show(
                'error',
                error.status,
                undefined,
                true,
                2000
              );
              return of(
                allActions.completePiCountSuccess({
                  status: false,
                  message: null,
                })
              );
            })
          );
      })
    );
  });

  getAllPiLocations$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(allActions.getAllPiLocations),
      mergeMap((action: any) => {
        return this.locationService
          .getLocationsAsObservable(0, 0, ['locationName', 'desc'])
          .pipe(
            map((res: any) => {
              return allActions.getAllPiLocationsSuccess({
                locations: res.data,
              });
            }),
            catchError(error => {
              return of(allActions.getAllPiLocationsSuccess({ locations: [] }));
            })
          );
      })
    );
  });

  addPiLocations$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(allActions.addPiLocation),
      mergeMap((action: any) => {
        return this.stockroomService
          .addPhysicalInventoryCountLocationAsObservable(
            action.piName,
            action.arrayOfLocations
          )
          .pipe(
            map((res: any) => {
              this.toastService.show(
                'success',
                'PI Count Location Created',
                '',
                true,
                3000
              );
              return allActions.addPiLocationsSuccess({ status: true });
            }),
            catchError(error => {
              this.toastService.show(
                'error',
                error.error.errorMessage,
                '',
                true,
                3000
              );
              return of(allActions.addPiLocationsSuccess({ status: false }));
            })
          );
      })
    );
  });

  editPiLocations$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(allActions.editPiLocation),
      mergeMap((action: any) => {
        return this.stockroomService
          .editPhysicalInventoryCountLocationAsObservable(
            action.piName,
            action.dataKey,
            action.arrayOfLocations
          )
          .pipe(
            map((res: any) => {
              this.toastService.show('success', res.status, '', true, 3000);
              return allActions.editPiLocationsSuccess({ status: true });
            }),
            catchError(error => {
              this.toastService.show(
                'error',
                error.error.errorMessage,
                '',
                true,
                3000
              );
              return of(allActions.editPiLocationsSuccess({ status: false }));
            })
          );
      })
    );
  });
}
